export default __webpack_public_path__ + "static/media/CADIcon-Yono.1ba69552.png";